import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  ButtonGroup,
} from '@chakra-ui/react';
import { type FC, useRef } from 'react';

interface ClearPageDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const ClearPageDialog: FC<ClearPageDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
}) => {
  const cancelRef = useRef(null);
  return (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={onClose}
      isCentered
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader>Clear all charts?</AlertDialogHeader>
          <AlertDialogBody>
            This will remove all charts from the current page. This action
            cannot be undone.
          </AlertDialogBody>
          <AlertDialogFooter>
            <ButtonGroup>
              <Button
                ref={cancelRef}
                variant="ghost"
                colorScheme="navyBlue"
                onClick={onClose}
              >
                Cancel
              </Button>
              <Button colorScheme="red" onClick={onConfirm}>
                Clear Page
              </Button>
            </ButtonGroup>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};
